
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/holiday-sweeps",
      function () {
        return require("private-next-pages/holiday-sweeps/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/holiday-sweeps"])
      });
    }
  